import { elements, helpers, modifiers } from '#components/generics/js/styles.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import { render } from '#utilities/js/template/template.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import * as tools from './tools.js'

const { open } = events

const containers = new WeakMap()

const onOpen = object(listener, {
  type: open,
  passive,
  task: async (opener, { detail: dropdown }) => {
    const container = containers.get(opener)
    const template = one('template', container)
    const templateContent = await render(template)
    const templateDateSelector = one(`.${helpers.dateSelector.elements.container}`, templateContent)
    const { dataset } = templateDateSelector
    const { targetName } = dataset
    const hidden = one(`.${modifiers.new_field_input.new_hidden}[name='${targetName}_day']`, container)

    if (hidden.value) {
      const date = new Date(hidden.value * 86400 * 1000)
      const dateSelector = one(`.${helpers.dateSelector.elements.container}`, dropdown)
      tools.setTargetValue(dateSelector, hidden.value)
      tools.setDays(dateSelector, date)
    }
  }
})

export default (container) => {
  const opener = one(`.${elements.button}`, container)

  onOpen.listen(opener)
  containers.set(opener, container)

  queueMicrotask(async () => {
    await removed(container)
    containers.delete(opener)
  })
}
